import { ref, watch } from 'vue';
import { useDictionaryStore } from '@/stores';
export default {
  name: 'DictionarySelect',
  props: {
    cate: {
      type: String,
      default: '',
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    prefixOptions: {
      type: Array,
      default: () => []
    },
    suffixOptions: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:value', 'select', 'update:text'],
  setup(props, {
    emit
  }) {
    const {
      getDictionaryList
    } = useDictionaryStore();
    const rows = ref([]);
    const loadDictionaryList = async cate => {
      const {
        error,
        rows: resRows
      } = await getDictionaryList(cate);
      if (error) return;
      rows.value = [...props.prefixOptions, ...resRows, ...props.suffixOptions];
    };
    const handleSelect = (value, option) => {
      emit('update:value', value);
      const selectValue = option.title;
      emit('select', selectValue);
      emit('update:text', selectValue);
    };
    const handleOpenDropdown = isOpen => {
      if (!isOpen) return;
      if (rows.value.length === 0) {
        loadDictionaryList(props.cate);
      }
    };
    watch(() => props.cate, cate => {
      if (!cate) return;
      loadDictionaryList(cate);
    }, {
      immediate: true
    });
    return {
      rows,
      handleSelect,
      handleOpenDropdown
    };
  }
};